<template>
    <div id="integrations">
        <AppBreadCrumb :paths="[{ title: $t('wp.whatsapp') }]" :select="true">
            <a-button
                class="actionButtonBreadcrumb"
                @click="unsubscribe"
                type="danger"
                v-if="initialized && status.purchased"
            >
                {{ $t("wp.unsubscribe") }}
            </a-button>

            <a-button
                class="actionButtonBreadcrumb ml-1"
                @click="debugModalVisible = true"
                type="danger"
                v-if="status.purchased"
            >
                {{ $t('whatsapp.wpDebugTool') }}
            </a-button>
        </AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex">
            <div class="side-menubar-wrapper">
                <WhatsappMenu selected-page="integration" />
            </div>
            <div class="main-content">
                <a-spin tip="Loading..." :spinning="!initialized">
                    <div class="spin-content">
                        <WhatsappWizard v-if="showWizard" />
                        <b-card v-else>
                            <b-card-body
                                class="h-100 d-flex flex-column justify-content-center align-items-center my-0"
                                style="min-height: 22vh"
                            >
                                <md-icon
                                    class="wp-icon-wp-integration mb-2 mr-1 ml-1"
                                    style="color: #06e576 !important; font-size: 60px !important"
                                >
                                    whatsapp
                                </md-icon>
                                <h4 style="margin-top: 5px">
                                    <p style="margin-bottom: 1px">
                                        {{ $t("wp.toEnableWpDescription") }}
                                    </p>
                                </h4>

                                <a-button @click="showWizard = true" type="primary" icon="unlock" size="large">
                                    {{ $t("wp.enableFeature") }}
                                </a-button>
                            </b-card-body>
                            <b-card-body
                                class="h-100 d-flex flex-column justify-content-center align-items-center my-2"
                                style="min-height: 22vh"
                            >
                                <template>
                                    <a-carousel
                                        style="height: 500px !important; width: 960px !important"
                                        arrows
                                        dots-class="slick-dots slick-thumb"
                                        :autoplay="true"
                                        dotPosition="bottom"
                                    >
                                        <div v-for="item in 3">
                                            <img :src="baseUrl[item - 1]" />
                                        </div>
                                    </a-carousel>
                                </template>
                            </b-card-body>
                        </b-card>
                    </div>
                </a-spin>
            </div>
        </div>

        <a-modal v-model="debugModalVisible" title="Whatsapp Service Debug Tool" centered class="debug-tool">
            <WhatsappDebugTool />
        </a-modal>
    </div>
</template>

<script>
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb";
import WhatsappWizard from "../../../../../components/whatsapp/WhatsappWizard";
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { updateIntegration } from "../../../../../api/billing";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import imgSrc1 from "../../../../../assets/img/wp_contact_1.jpg";
import imgSrc2 from "../../../../../assets/img/wp_contact_2.jpg";
import imgSrc3 from "../../../../../assets/img/wp_contact_3.jpg";
import WhatsappMenu from "../../components/WhatsappMenu";
import "../../whatsapp.scss";
import WhatsappDebugTool from "../../components/WhatsappDebugTool";

export default {
    name: "WhatsappIntegration",
    components: {
        AppBreadCrumb,
        WhatsappWizard,
        WhatsappMenu,
        WhatsappDebugTool,
    },
    computed: {
        ...mapGetters({
            isHealthy: "whatsapp/isHealthy",
        }),
        ...mapState({
            siteId: (state) => state.site.site._id,
            initialized: (state) => state.whatsapp.info.initialized,
            status: (state) => state.whatsapp.info.status,
        }),
    },
    data() {
        return {
            showWizard: false,
            baseUrl: [imgSrc1, imgSrc2, imgSrc3],
            debugModalVisible: false,
        };
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePurchaseStatus: "whatsapp/changePurchaseStatus",
        }),
        async unsubscribe() {
            const self = this;
            this.$confirm({
                title: this.$t("wp.cancelWpInetgration"),
                content: this.$t("wp.terminatelWpInetgration"),
                okText: this.$t("wp.unsubscribeWpInetgration"),
                okType: "danger",
                cancelText: this.$t("wp.wpBack"),
                width: 600,
                height: 600,
                async onOk() {
                    await updateIntegration(self.siteId, "whatsapp", false);
                    self.getSettings();
                    sendSocketMessage("user settings-updated", {
                        siteId: self.siteId,
                    });
                    self.showWizard = false;
                    localStorage.removeItem("wp-agreement-accepted");
                    self.changePurchaseStatus(false);
                    sendSocketMessage("whatsapp unsubscribe", {
                        siteId: self.siteId,
                    });
                },
                onCancel() {},
            });
        },
    },
    mounted() {
        if (this.status.purchased) {
            this.showWizard = true;
        }
    },

    watch: {
        status(newStatus) {
            if (newStatus.purchased) {
                this.showWizard = true;
            }
        },
    },
};
</script>

<style lang="scss">
#integrations {
    .custom-button {
        min-width: 35px;
        height: 35px;
        background-color: #f3f6f9;
        border-radius: 8px;
        margin: 8px;
    }

    .ant-carousel > .slick-dots {
        position: unset !important;
    }

    .ant-carousel .slick-dots {
        position: unset !important;
    }

    .ant-carousel .slick-dots-bottom {
        position: initial !important;
    }

    .ant-carousel {
        .slick-slide {
            img {
                border: 5px solid #fff;
                display: block;
                margin: auto;
                max-width: 80%;
            }
        }
    }

    .ant-carousel {
        .slick-thumb {
            bottom: 0px;
        }
    }

    .ant-carousel > .slick-thumb li {
        width: 10px;
        height: 10px;
    }

    .ant-carousel > .slick-thumb li img {
        width: 100%;
        height: 100%;
        filter: grayscale(100%);
    }

    .ant-carousel .slick-dots li {
        background-color: #1890ff;
    }

    .ant-carousel .slick-dots li.slick-active button {
        background-color: #1890ff;
    }

    .ant-carousel > .slick-thumb li.slick-active img {
        filter: grayscale(0%);
    }
}
</style>
